import React, { useState } from "react";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { useTranslation } from "react-i18next";
import { TextField } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import { parseAxiosError } from "../../../utils/response";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../utils/consts";

import DefaultButton from "../../styles/materialButtonStyle";
import { StyledSupportUserCreate, StyledSupportUserCreateForm } from "../styledSupportUser";
import MaterialDialog from "../../styles/materialDialog";
import {
  StyledDialogAction,
  StyledDialogContent,
  StyledDialogHead,
  StyledDialogWrapper
} from "../../styles/styledDialog";

const SupportUserForm = ({ notification, setNotification, setFetch }) => {
  const DEFAULT_USER_INFO = {
    email: null,
    password: null,
    secret: null
  };

  const { t } = useTranslation("supportUserPage");

  const [userInfo, setUserInfo] = useState(DEFAULT_USER_INFO);

  const [open, setOpen] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const onSubmit = (event) => {
    event.preventDefault();

    setDisabled(true);

    let userData = {
      userEmail: event.target.email.value.trim(),
      firstname: event.target.firstname.value.trim(),
      lastname: event.target.lastname.value.trim(),
      role: "support"
    };

    if (!userData.userEmail || !userData.firstname || !userData.lastname) {
      setNotification({ ...notification, visible: true, type: "error", message: t("createForm.requiredError") });
      setDisabled(false);

      return;
    }

    axios.post("/api/create-user", userData, userAuthenticationConfig(false)).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_CREATED) {
        setUserInfo(response.data);
        setFetch(true);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => setDisabled(false));
  };

  const handleClickOpen = () => {
    setOpen(true);
    setUserInfo(DEFAULT_USER_INFO);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <StyledSupportUserCreate className="support-user-head__create">
      <DefaultButton
        color="success"
        onClick={handleClickOpen}
      >
        {t("createForm.title")}
      </DefaultButton>
      <MaterialDialog
        open={open}
      >
        <StyledDialogWrapper as="form" onSubmit={onSubmit}>
          <StyledDialogHead>
            {userInfo.password && userInfo.secret ? t("createForm.resultTitle") : t("createForm.title")}
          </StyledDialogHead>
          {userInfo.password && userInfo.secret ?
            <StyledDialogContent>
              <Alert severity="info">
                <StyledSupportUserCreateForm>
                  <div className="generate-data">
                    <div className="generate-data__key">
                      E-mail:
                    </div>
                    <div className="generate-data__value">
                      {userInfo.email}
                    </div>
                  </div>
                  <div className="generate-data">
                    <div className="generate-data__key">
                      {t("createForm.password")}:
                    </div>
                    <div className="generate-data__value">
                      {userInfo.password}
                    </div>
                  </div>
                  <div className="generate-data">
                    <div className="generate-data__key">
                      {t("createForm.twoFa")}:
                    </div>
                    <div className="generate-data__value">
                      {userInfo.secret}
                    </div>
                  </div>
                </StyledSupportUserCreateForm>
              </Alert>
            </StyledDialogContent> :
            <StyledDialogContent>
              <TextField
                id="email"
                name="email"
                label="E-mail"
              />
              <TextField
                id="firstname"
                name="firstname"
                label={t("createForm.firstname")}
              />
              <TextField
                id="lastname"
                name="lastname"
                label={t("createForm.lastname")}
              />
            </StyledDialogContent>}
          <StyledDialogAction col="2">
            {userInfo.password && userInfo.secret ?
              <>
                <CopyToClipboard
                  text={`E-mail: ${userInfo.email}
Password: ${userInfo.password}
Two-FA Secret: ${userInfo.secret}`}
                  onCopy={() => {
                    setNotification({
                      ...notification,
                      visible: true,
                      type: "success",
                      message: t("createForm.copied")
                    });
                  }}
                >
                  <DefaultButton
                    color="transparent"
                    type="button"
                  >
                    {t("createForm.copy")}
                  </DefaultButton>
                </CopyToClipboard>
                <CopyToClipboard
                  text={`E-mail: ${userInfo.email}
Password: ${userInfo.password}
Two-FA Secret: ${userInfo.secret}`}
                  onCopy={() => {
                    setNotification({
                      ...notification,
                      visible: true,
                      type: "success",
                      message: t("createForm.success")
                    });
                  }}
                >
                  <DefaultButton
                    type="button"
                    color="success"
                    onClick={handleClose}
                  >
                    {t("createForm.done")}
                  </DefaultButton>
                </CopyToClipboard>
              </>
              :
              <>
                <DefaultButton
                  onClick={handleClose}
                  color="danger"
                  type="button"
                  disabled={disabled}
                >
                  {t("createForm.cancel")}
                </DefaultButton>
                <DefaultButton
                  color="success"
                  type="submit"
                  disabled={disabled}
                >
                  {t("createForm.create")}
                </DefaultButton>
              </>
            }
          </StyledDialogAction>
        </StyledDialogWrapper>
      </MaterialDialog>
    </StyledSupportUserCreate>
  );
};

export default SupportUserForm;